import i18n from '@/i18n';
const Layout = () => import('@/layouts/main.vue');
const SurveysImage = () => import('./views/Index.vue');

export default [
  {
    path: '/surveys-image',
    component: Layout,
    meta: { authRequired: true, header: true, permission: 'superadmin|marketing' },
    children: [
      {
        path: '',
        name: 'SurveysImage',
        component: SurveysImage,
        meta: { title: i18n.global.t('surveys.image') },
      },
    ],
  },
];
